import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import PartyTargetVsAchivementTable from './partTargetVsAchivementReportTable'
import { connect } from 'react-redux'
import { getPatyTargetAchivementReportFilterData, getPartyTargetAchivementReportData } from '../../../../store/reports/reports_action'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
const PartyTargetVsAchivement = (props) => {
    const { data: { common, reports }, getPatyTargetAchivementReportFilterData, getPartyTargetAchivementReportData, updateAlertError } = props
    const { loginData } = common
    const { partyTargetAchivmentFilterData, partyTargetAchivmentReportData } = reports
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [showReport, setShowReport] = useState(false)
    const [filterCityList, setFilterCityList] = useState([]);
    const [filterPartyList, setFilterPartyList] = useState([]);
    const [filteredParties, setFilteredParties] = useState([]);
    const [partyCity, setPartyCity] = useState()
    const [party, setParty] = useState()
    const [tableData, setTableData] = useState([])
    useEffect(() => {
        if (partyTargetAchivmentFilterData?.length > 0) {
            const cityMap = new Map();
            const partyMap = new Map();

            partyTargetAchivmentFilterData.forEach((item) => {
                // Add unique city details
                if (!cityMap.has(item.CityID)) {
                    cityMap.set(item.CityID, { CityName: item.CityName, CityID: item.CityID });
                }
                // Add unique party details
                if (!partyMap.has(item.PartyID)) {
                    partyMap.set(item.PartyID, { PartyName: item.PartyName, PartyID: item.PartyID, CityID: item.CityID });
                }
            });
            setFilterCityList([{CityID:0,CityName:'ALL'},...cityMap.values()]);
            setFilterPartyList([{PartyID:0,PartyName:'ALL'},...partyMap.values()]);
            setFilteredParties([...partyMap.values()])//for filterporpose
            setParty({PartyID:0,PartyName:'ALL'})
            setPartyCity({CityID:0,CityName:'ALL'})
        }
    }, [partyTargetAchivmentFilterData]);
    useEffect(() => {
        if (partyTargetAchivmentReportData?.length > 0) {
            let data = partyTargetAchivmentReportData.map((item, index) => ({
                ...item,
                SN: index + 1,
                targetType: 'Amount',
                TargetStartDate: item?.TargetStartDate === '' ? '' : moment(item.TargetStartDate).format('DD MMM YYYY'),
                TargetEndDate: item?.TargetEndDate === '' ? '' : moment(item.TargetEndDate).format('DD MMM YYYY'),
            }));
    
            // Calculate totals
            const totals = data.reduce(
                (acc, item) => {
                    acc.TargetAmount += item.TargetAmount || 0;
                    acc.TargetProgress += parseFloat(item.TargetProgress) || 0;
                    acc.TotalLRs += item.TotalLRs || 0;
                    acc.TotalItems += item.TotalItems || 0;
                    acc.TotalNetAmounts += item.TotalNetAmounts || 0;
                    return acc;
                },
                {
                    TargetAmount: 0,
                    TargetProgress: 0,
                    TotalLRs: 0,
                    TotalItems: 0,
                    TotalNetAmounts: 0,
                }
            );
            const totalRow = {
                isTotal: true,
                SN: 'Total',
                TargetAmount: totals.TargetAmount,
                TargetProgress: totals.TargetProgress,
                TotalLRs: totals.TotalLRs,
                TotalItems: totals.TotalItems,
                TotalNetAmounts: totals.TotalNetAmounts,
            };
            data.push(totalRow);
    
            setTableData(data);
        } else {
            setTableData([]);
        }
    }, [partyTargetAchivmentReportData]);
    
    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
    const generateReport = () => {
        setShowReport(true)
        if (partyCity == '' || partyCity == ' ') {
            updateAlertError({ show: true, msg: 'Select City', nextId: '' })
        } else if (party == "" || party == ' ') {
            updateAlertError({ show: true, msg: 'Select Party Name', nextId: '' })
        } else {
            const obj = {
                CompanyID: loginData?.intCompanyID,
                CityID: partyCity?.CityID,
                PartyID: party?.PartyID,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
            }
            getPartyTargetAchivementReportData(obj)
        }
    }
    const handleGoClick = () => {
        // if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
        //     updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        // } else {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            PartyID: 0,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
        }
        getPatyTargetAchivementReportFilterData(obj)
        // }
    }
    const selectedPartyCity = (obj) => {
        setShowReport(false);
        setPartyCity(obj);
        // Filter the party list based on selected city
        const filtered = filteredParties.filter((val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val?.CityID === 0 || obj.CityID === 0);
        setFilterPartyList([{PartyID:0,PartyName:'ALL'},...filtered]);
        setParty({PartyID:0,PartyName:'ALL'})
        // Set the first party of the selected city as the default selected party
        // if (filtered.length > 0) {
        //     setParty(filtered[0]);
        // }
    };
    const reportName = 'Party Business Report'
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <ReportHeading reportName={reportName} />
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            // id={id.selectCompnay}
                            label={"Select Company"}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => setSelCompany(val)}
                            width="300px"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary" >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Booking Date`}
                            name={'from_date'}
                            value={fromDate}
                            id={'fromDate'}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Booking Date'}
                            name={'to_date'}
                            value={toDate}
                            id={'toDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goButtonDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            id={'goButtonDate'}
                            onClick={handleGoClick}
                            onKeyDown={(e) => { navigation3(e, 'selectedCity', 'toDate', () => handleGoClick()) }}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={`Select Party City`}
                            id={'selectedCity'}
                            data={filterCityList || []}
                            // disabled={disableBtn}
                            defaultvalue={partyCity?.CityName || partyCity}
                            dataKey={`CityName`}
                            idKey={`CityID`}
                            onSelect={(obj) => { selectedPartyCity(obj) }}
                            // onSelect={(val) => { setShowReport(false); setPartyCity(val) }}
                            width="100%"
                            nextId={'selectedBranch'}
                            prevId={'goButtonDate'}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={'selectedBranch'}
                            label={'Select Party Name'}
                            data={filterPartyList || []}
                            defaultvalue={party?.PartyName || party}
                            dataKey={`PartyName`}
                            idKey={`PartyID`}
                            // onSelect={(val) => { selectedSourceBranch(val) }}
                            onSelect={(val) => { setShowReport(false); setParty(val) }}
                            nextId={'generateButton'}
                            prevId={'selectedCity'}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx}
                        onKeyDown={(e) => { navigation3(e, showReport ? "ExpToExlbtn" : 'fromDate', 'selectedBranch', () => generateReport()) }}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            // hideToggle={false}
                            id1={'generateButton'}
                            onClick1={generateReport}
                        // onClick2={handleClick2}
                        />
                    </Item>
                </Box>
            </Item>
            {
                showReport ? <PartyTargetVsAchivementTable tableData={tableData} loginData={loginData} partyCity={partyCity} party={party} fromDate={fromDate} toDate={toDate} /> : ''
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getPatyTargetAchivementReportFilterData, getPartyTargetAchivementReportData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(PartyTargetVsAchivement)